export default function loadModules() {

  // Dynamisch alle beschikbare component scripts ophalen
  const modules = import.meta.glob('../../views/components/**/script.js');
  
  document.querySelectorAll('[data-layout]').forEach(async (element) => {

    //console.log('found block:', element);

    const layout = element.getAttribute('data-layout');

    if (!layout) return;

    // Zoek de juiste module op basis van `data-layout`
    const modulePath = `../../views/components/${layout}/script.js`;

    if (!modules[modulePath]) {
      //console.error(`❌ Geen script gevonden voor: ${layout}`);
      return;
    }

    try {
      const strategy = determineLoadingStrategy(element);
      const loadFunction = getLoadingFunctionWrapper(strategy, element);

      // Dit zorgt dat alles binenen de defaults  geladen word
      loadFunction(() => {
        modules[modulePath]()
          .then((mod) => {
            //console.log('this is:', mod);
            mod.default(element);
            //console.log('module loaded:', element);
            element.classList.add('is-loaded');

            // Zoek of er een styles.css is die bij dit script hoort
            // const cssPath = getGeneratedCSSPath(scriptPath);
            // if (cssPath) {
            //   console.log(`✅ Styles geladen voor: ${layout}`);
            //   loadCSS(cssPath);
            // }

          })
          .catch((error) => {
            console.error(`❌ Fout bij laden van module voor: ${layout}`, error);
          });
      });

    } catch (error) {
      console.error(`❌ Kan module niet laden voor: ${layout}`, error);
    }
  });
}

// Functie om de bijbehorende CSS te laden als die bestaat
// function loadCSS(cssPath) {
//   if (!document.querySelector(`link[href="${cssPath}"]`)) {
//     const link = document.createElement('link');
//     link.rel = 'stylesheet';
//     link.href = cssPath;
//     document.head.appendChild(link);
//   }
// }

// // Functie om te bepalen waar de gegenereerde styles.css zich bevindt
// function getGeneratedCSSPath(scriptPath) {
//   // Vite genereert CSS met een hash, maar de relatie blijft behouden
//   // Dit moet aangepast worden als je andere structuren gebruikt.
//   const cssFileName = scriptPath.replace('/script.js', '/styles.css');
//   const cssPath = `/app/themes/mintis-starter/public/build/assets/${cssFileName}`;

//   return cssPath; // Retourneer het pad als het bestaat
// }

// Functie om de loading-strategie te bepalen
function determineLoadingStrategy(node) {
  const strategies = {
    load: 'load', // Direct laden
    idle: 'idle', // Laden tijdens idle tijd
    visible: 'visible', // Laden wanneer zichtbaar
    interaction: 'interaction', // Laden na interactie
  };

  return strategies[node.getAttribute('data-load-on')] ?? 'load';
}

// Wrapper voor de loading-functie
function getLoadingFunctionWrapper(strategy, node) {
  const loadingFunctions = {
    load: (fn) => fn(), // Direct uitvoeren
    idle: (fn) => requestIdleCallback(fn, { timeout: 2000 }), // Laden tijdens idle tijd
    visible: async (fn) => {
      await visible(node); // Wacht tot het zichtbaar is
      fn();
    },
    interaction: (fn) => {
      const load = () => {
        document.removeEventListener('click', load);
        fn();
      };
      document.addEventListener('click', load, { once: true });
    },
  };

  return loadingFunctions[strategy] ?? loadingFunctions.load;
}

// Functie om te wachten tot een element zichtbaar is
function visible(node) {
  return new Promise((resolve) => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        resolve(true);
      }
    });
    observer.observe(node);
  });
}



// export default function loadModules() {
//   const modules = [
//     {
//       selector: '.component--slider__images', // Alleen sliders laden
//       module: () => import('../../views/components/slider__images/script.js'), // Correct pad naar de slider-module
//     },
//     {
//       selector: '.component--slider__posts',
//       module: () => import('../../views/components/slider__posts/script.js'), 
//     },
//     // Voeg hier andere modules toe
//   ];

//   modules.forEach(({ selector, module }) => {
//     const elements = document.querySelectorAll(selector);

//     if (!elements.length) return;

//     elements.forEach((element) => {
//       // Bepaal de laadstrategie
//       const strategy = determineLoadingStrategy(element);
//       const loadFunction = getLoadingFunctionWrapper(strategy, element);

//       // loadFunction(() => {
//       //   module()
//       //     .then((mod) => mod.default(element)) // Voer de standaard export van de module uit
//       //     .catch((error) =>
//       //       console.error(`Error loading module for selector "${selector}":`, error)
//       //     );
//       // });

//       loadFunction(() => {
//         module()
//           .then((mod) => {
//             mod.default(element); // Initialiseer de functionaliteit
//             element.classList.add('is-loaded'); // Voeg de klasse toe om zichtbaar te maken
//           })
//           .catch((error) => {
//             console.error(`Error loading module for selector "${selector}":`, error);
//           });
//       });

//     });
//   });
// }


// alles hieronder bewaren en herzien

// werkt en is efficienter dan hieronder
// // export default function loadModules() {
//   // Gebruik import.meta.glob om alle component-modules te vinden
//   const modules = import.meta.glob('../../components/**/!(*.test).js'); // Excludeer testbestanden

//   // Itereer over alle gevonden modules
//   Object.entries(modules).forEach(([path, module]) => {
//     // Match selector uit het pad (bijvoorbeeld 'slider__images' -> '.component--slider')
//     const selector = `.component--${path.split('/').slice(-2, -1)[0].replace(/_/g, '_')}`;

//     console.log('Loading module for selector:', selector);

//     if (document.querySelector(selector)) {
//       module()
//         .then((mod) => mod.default())
//         .catch((error) =>
//           console.error(`Error loading module for selector "${selector}":`, error)
//         );
//     }
//   });
// }

// werkend voorbeeld
// export default function loadModules() {
//   // Module-specific imports
//   const modules = [
//     {
//       selector: '.component--slider', // Alleen laden als een slider aanwezig is
//       module: () => import('../../components/slider__images/slider'),
//     },
//     {
//       selector: '[data-anchor]', // Placeholder voor andere functionaliteiten
//       module: () => ''
//         //import('../components/anchor-block'),
//     },
//     {
//       selector: '.menu-toggle', // Voor het laden van een menu-module
//       module: () => ''
//         //import('../components/menu'),
//     },
//   ];

//   // Itereer over alle modules en laad alleen als de selector aanwezig is
//   modules.forEach(({ selector, module }) => {
//     if (document.querySelector(selector)) {
//       module()
//         .then((mod) => mod.default()) // Roep de standaard export aan
//         .catch((error) =>
//           console.error(`Error loading module for selector "${selector}":`, error)
//         );
//     }
//   });
// }

// The  difference of the code below is that it uses async/await for better error handling. 
// the code above uses the .then() method to handle the promise.

// export default async function loadModules() {
//   const modules = [
//     {
//       selector: '.slider',
//       module: () => import('../components/slider'),
//     },
//     {
//       selector: '[data-anchor]',
//       module: () => import('../components/anchor-block'),
//     },
//     {
//       selector: '.menu-toggle',
//       module: () => import('../components/menu'),
//     },
//   ];

//   // Gebruik async/await voor betere foutafhandeling
//   await Promise.all(
//     modules.map(async ({ selector, module }) => {
//       if (document.querySelector(selector)) {
//         try {
//           const mod = await module();
//           mod.default(); // Roep de standaard export van de module aan
//         } catch (error) {
//           console.error(`Error loading module for selector "${selector}":`, error);
//         }
//       }
//     })
//   );
// }